'use strict';

module.exports = {
  user: 'user',
  observedAssortment: 'observedAssortment',
  preOptimisationAssortment: 'preOptimisationAssortment',
  preCopyDecisions: 'preCopyDecisions',
  startingAssortment: 'startingAssortment',
  previousAssortment: 'previousAssortment',
};
